import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const channels = [
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "汽车新闻",
    desc: "上市、改款与市场最新报道",
  },
  {
    to: "/reviews",
    icon: "ri-speed-up-line",
    title: "车型评测",
    desc: "深度试驾与专业对比分析",
  },
  {
    to: "/industry",
    icon: "ri-building-2-line",
    title: "行业动态",
    desc: "政策、技术与产业趋势",
  },
];

export default function CategoryQuickEntry() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 mt-8 relative z-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {channels.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="group flex items-center gap-4 bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-400 transition-colors cursor-pointer"
          >
            <span className="w-14 h-14 rounded-lg bg-primary-600 flex items-center justify-center shrink-0 group-hover:bg-accent-500 transition-colors">
              <i className={`${item.icon} text-2xl text-background-50 group-hover:text-primary-950`} />
            </span>
            <span className="min-w-0">
              <span className="block font-heading font-semibold text-lg text-foreground-950">
                {item.title}
              </span>
              <span className="block text-sm text-foreground-500 mt-0.5">
                {item.desc}
              </span>
            </span>
            <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-accent-500 transition-colors" />
          </Link>
        ))}
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2 bg-background-50 border border-background-200 rounded-lg px-4 py-3">
        <span className="text-sm text-foreground-600 mr-1 flex items-center gap-1.5">
          <i className="ri-price-tag-3-line text-accent-500" />
          热门分类：
        </span>
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/news/${cat.id}`}
            className="px-3 py-1 rounded-full text-sm bg-secondary-100 text-secondary-900 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {cat.name}
          </Link>
        ))}
      </div>
    </section>
  );
}